(() => {
  const root = document.querySelector('.woh-newsletter-page__form');
  if (!root) return;

  // Klaviyo inserts and updates this embed asynchronously. Only correct its
  // display text and the contact link; submission and consent remain app-owned.
  const refresh = () => {
    root.querySelectorAll('[role="alert"]').forEach((alert) => {
      if (alert.textContent.trim() === 'This field is required' && root.dataset.requiredMessage) {
        if (alert.textContent !== root.dataset.requiredMessage) {
          alert.textContent = root.dataset.requiredMessage;
        }
      }
    });
    root.querySelectorAll('a').forEach((link) => {
      if (link.textContent.trim().toLowerCase() === 'service@wohunderwear.com') {
        link.setAttribute('href', 'mailto:service@wohunderwear.com');
      }
    });
  };
  refresh();
  const observer = new MutationObserver(refresh);
  observer.observe(root, { childList: true, subtree: true, characterData: true });
})();
